export default "__VITE_ASSET__BBP6UKjG__"